import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  toggle(event) {
    const following = event.target.checked

    fetch(this.element.dataset.contentTypeFollowerUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ following })
    })
  }
} 
